import { UserSettingsDTO } from '../data/dtos/user-settings.dto';

export class MobileBannerService {
    static $inject: string[] = [
        'STATIC_IMAGES_PATH'
    ];

    constructor(protected STATIC_IMAGES_PATH) {

    }

    setMobileBanner(userSettings: UserSettingsDTO) {
        const isStaffMember = !userSettings || (userSettings && userSettings.IsManagerUser);
        if (isStaffMember) {
            // iOS
            const iosMetaTag = document.createElement('meta');
            iosMetaTag.name = 'apple-itunes-app';
            iosMetaTag.content = 'app-id=1288105237';
            document.getElementsByTagName('head')[0].appendChild(iosMetaTag);

            const iosLinkTag = document.createElement('link');
            iosLinkTag.rel = 'apple-touch-icon';
            iosLinkTag.href = `${this.STATIC_IMAGES_PATH}/apple-touch-icon.png`;
            document.getElementsByTagName('head')[0].appendChild(iosLinkTag);

            // Android
            const androidMetaTag = document.createElement('meta');
            androidMetaTag.name = 'google-play-app';
            androidMetaTag.content = 'app-id=com.buildium.android';
            document.getElementsByTagName('head')[0].appendChild(androidMetaTag);

            const androidLinkTag = document.createElement('link');
            androidLinkTag.rel = 'android-touch-icon';
            androidLinkTag.href = `${this.STATIC_IMAGES_PATH}/apple-touch-icon.png`;
            document.getElementsByTagName('head')[0].appendChild(androidLinkTag);
        }
    }
}
